import { create } from "zustand";
import { persist } from "zustand/middleware";

// Client workspace/UI state (persisted). Never holds ticks/candles — the Market Data Engine owns the firehose.
export const useUiStore = create(persist((set) => ({
  dock: { activePanel: null, width: 360 },
  chartType: "candlestick",
  showVolume: true,
  activeInd: [],
  structureFlags: { swings: false, bos: true, choch: true, cisd: true, t50: true, twoBOneA: false, fvg: false, ob: false, liq: false },
  showConfluence: true,
  scaleMode: "normal", // normal | percent | log
  accountMode: "demo", // demo | live — VIEWING mode only; LIVE execution is authorized server-side, never here
  setAccountMode: (accountMode) => set({ accountMode }),
  sidebarCollapsed: false, // desktop: hamburger hides the main sidebar so the chart takes the full width
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setScaleMode: (scaleMode) => set({ scaleMode }),
  tradeIntent: null, // { ctype: "CALL"|"PUT", at }
  tradeBarrier: null, // { symbol, price, kind: "touch"|"hl", ctype } — live barrier preview drawn on the chart (not persisted)
  setTradeBarrier: (tradeBarrier) => set({ tradeBarrier }),
  setPanel: (id) => set((s) => ({ dock: { ...s.dock, activePanel: s.dock.activePanel === id ? null : id } })),
  closePanel: () => set((s) => ({ dock: { ...s.dock, activePanel: null } })),
  openPanel: (id) => set((s) => ({ dock: { ...s.dock, activePanel: id } })),
  setChartType: (chartType) => set({ chartType }),
  setShowVolume: (showVolume) => set({ showVolume }),
  setActiveInd: (activeInd) => set({ activeInd }),
  setStructureFlags: (fn) => set((s) => ({ structureFlags: typeof fn === "function" ? fn(s.structureFlags) : fn })),
  setShowConfluence: (showConfluence) => set({ showConfluence }),
  setTradeIntent: (tradeIntent) => set({ tradeIntent }),
}), { name: "rio.ui", partialize: (s) => ({ dock: s.dock, chartType: s.chartType, showVolume: s.showVolume, activeInd: s.activeInd, structureFlags: s.structureFlags, showConfluence: s.showConfluence, scaleMode: s.scaleMode, accountMode: s.accountMode, sidebarCollapsed: s.sidebarCollapsed }) }));

// Bridge from the mounted ChartPanel to dock panels (drawings/objects, structure) — not persisted.
export const useChartBridge = create((set) => ({ bridge: null, setBridge: (bridge) => set({ bridge }) }));
